import axios from "axios";
import ENV from "../Environments";
import interceptor from "../native/interceptors";
import { ENVIRONMENT } from "../native/constants";

const Axios = axios.create({
	baseURL: ENV.getBaseUrl(),
	timeout: 30000
});

const isProd = () => ENV.getEnvironment() === ENVIRONMENT.PROD;

export default Axios;


const isAuthApi = (config) => {
	if (!config.url) return true;
	switch (config.url) {
		default: return true;
	}
}



function encodeServiceMeta(meta) {
	return encodeURI(meta).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']').replace(/@/gi, '%40');
}

export const encodeQueryParams = (params) => {
	if (params && Object.keys(params).length > 0) {
		const ret = [];
		for (const param in params) {
			if (param === 'serviceMeta') {
				ret.push(param + '=' + encodeServiceMeta(JSON.stringify(params[param])))
			} else if (param === 'sourceName') {
				let value = (params[param]);
				value = value.replace(/ /g, '+');
				ret.push(param + '=' + value);
			} else {
				ret.push(param + '=' + params[param]);
			}
		}
		return '?' + ret.join('&')
	}
	return ''
}


Axios.interceptors.request.use(async (config) => {
	try {
		const headers = await interceptor().generateHeaders({
			method: config?.method?.toUpperCase(),
			body: config.data ? JSON.stringify(config.data) : "",
			url: config.baseURL?.concat("/", config.url, encodeQueryParams(config.params))
		});
		if (!headers) {
			throw new Error('Failed');
		}
		if (!isAuthApi(config) || !isProd()) {
			delete headers['z-access-token'];
		}
		const isAuth = checkIfAuthorized(headers, config);
		if (!isAuth) {
			return {};
		}
		for (const header in headers) {
			config.headers[header] = headers[header];
		}
	}
	catch (ex) {
		console.error(ex);
	}
	return config;
});

Axios.interceptors.response.use(
	(response) => {
		return response?.data;
	},
	async (error) => {
		const { status } = error?.response || {};
		const { errorMessage } = error?.response?.data || {};
		console.error(status, errorMessage, error);

		return error?.response;
	}
);


const checkIfAuthorized = () => {
	return true;
}
